import React, { useEffect, useState } from 'react';
import { Delete, Edit } from '@mui/icons-material';
import { IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, TextField } from '@mui/material';
import { generateID } from '../../../utils/common';

const ManageItemsListComponent = (props) => {
  const [editMode, setEditMode] = useState(false);
  const [itemName, setItemName] = useState('');
  const [editItemId, setEditItemId] = useState(undefined);

  const { items, addItemInList, deleteItemFromList, editIteminList } = props;

  useEffect(() => {
    cancelEditing();
  }, [items]);

  const handleChange = (e) => {
    const { value } = e.target;
    setItemName(value);
  };

  const changeToEditMode = (item) => {
    setItemName(item.label);
    setEditItemId(item.id);
    setEditMode(true);
  };

  const onSubmit = () => {
    if (itemName !== '' && itemName !== null) {
      if (!editMode) {
        addItemInList({
          id: generateID(),
          value: itemName.replace(' ', '__-'),
          label: itemName,
        });
      } else {
        editIteminList({
          id: editItemId,
          value: itemName.replace(' ', '__-'),
          label: itemName,
        });
      }
    }
  };

  const cancelEditing = () => {
    setEditMode(false);
    setItemName('');
    setEditItemId(undefined);
  };

  return (
    <>
      <div>
        <TextField
          label="Item Name"
          name="newItem"
          value={itemName}
          onChange={handleChange}
          style={{ minWidth: '100%' }}
        />
        <input
          className="btn btn-light btn-shadow m-t-20 m-r-10"
          value={editMode ? 'Edit Item' : 'Add Item'}
          type="button"
          onClick={onSubmit}
        />
        {editMode && (
          <input
            className="btn btn-light btn-shadow m-t-20 m-r-10"
            value="Cancel"
            type="button"
            onClick={cancelEditing}
          />
        )}
        <List component="nav">
          {items?.map((item) => (
            <ListItem key={item.value}>
              <ListItemText primary={item.label} />
              <ListItemSecondaryAction>
                <IconButton edge="end" onClick={() => changeToEditMode(item)}>
                  <Edit />
                </IconButton>
                <IconButton onClick={() => deleteItemFromList(item)} edge="end">
                  <Delete />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </div>
    </>
  );
};

export default ManageItemsListComponent;
